import Vue from "vue";
import ByMessageBox from "./ByMessageBox.vue";

const ByMessageBoxConstructor = Vue.extend(ByMessageBox);

function byMessageBox(options = {}) {
  const instance = new ByMessageBoxConstructor({
    propsData: {
      width: options.width || "400px",
      top: options.top || "35vh",
      title: options.title || "提示",
      content: options.content || "确认执行此操作吗？",
      title: options.title || "提示",
      message: options.message || "确认执行此操作吗？",
      showCancelButton: options.showCancelButton || false,
      showConfirmButton:
        options.showConfirmButton === undefined ? true : options.showConfirmButton,
      confirmButtonText: options.confirmButtonText || '确定',
      cancelButtonText: options.cancelButtonText || '取消',
      type: options.type || "warning",
    },
  });

  document.body.appendChild(instance.$mount().$el);

  return instance.show();
}

export default byMessageBox;



// WEBPACK FOOTER //
// ./src/components/backstageManagement/public/ByMessageBox/ByMessageBox.js